<div data-cy="generic-share-items__page">
    <div class="flex pr-15 gap-22" [ngClass]="{'align-center': isReadOnly,'align-baseline': !isReadOnly}">
        <div class="flex" *ngIf="avatarProjects.length>0 && !isReadOnly">
            <!-- Show avatars for filtered projects -->
            <ng-container *ngFor="let proj of avatarProjects">
                <ngx-avatars
                    [name]="globals.project.projects_id===proj.source_project.id ? proj.target_project.name: proj.source_project.name"
                    size="25"
                    [style]="AvatarCustomStyle"
                    initialsSize="2"
                    textSizeRatio="2.5"
                    [borderColor]="proj.color"
                    fgColor="#000000"
                    bgColor="#FFFFFF"
                >
                </ngx-avatars>
            </ng-container>

                <!-- Show "+X" if more than 4 avatars -->
            <ng-container *ngIf="avatarProjects.length>4">
                <ngx-avatars
                    [name]="'+ ' + (avatarProjects.length - 4)"
                    size="25"
                    [style]="AvatarCustomStyle"
                    initialsSize="2"
                    textSizeRatio="2.5"
                    fgColor="#000000"
                    bgColor="#FFFFFF"
                >
                </ngx-avatars>
            </ng-container>
        </div>
        <span class="flex align-center justify-btw notification-wrapper px-20 gap-30 -mt-5" [class.w-400]="type==='contactpersons' || type==='activities'" *ngIf="isReadOnly">
            <span class="flex align-center gap-20 py-5">
                <mat-icon class="bell">notifications_none</mat-icon>
                <p [style.font-weight]="600" class="mb-0">{{'shared_projects.notify' | transloco }}</p>
            </span>
            <i class="d-text-middle uil uil-multiply"></i>
        </span>

        <button data-cy="generic-share-items__btn" mat-stroked-button *ngIf="isReadOnly" (click)="!isReader && toggleStatusDropdown()" [disabled]="isReader">
            <i class="uil uil-volume-mute"></i>
            <span class="share-item-text">{{'shared_projects.muted' | transloco }}</span>
        </button>

        <div class="status-dropdown" *ngIf="isStatusPanleOpen && !isReader">
            <div class="flex justify-btw align-center">
                <span class="fs-20 pl-5">{{'shared_projects.shared_info_status' | transloco }}</span>
                <i data-cy="generic-share-items__icon-action" class="d-text-middle uil uil-multiply d-cursor-hand" (click)="isStatusPanleOpen=false"></i>
            </div>

            <div class="stats-grp mt-12 pl-5">
                <p>{{'shared_projects.shared_desc' | transloco }}</p>
                 <mat-button-toggle-group data-cy="generic-share-items__status-levels" name="statusLevels" [(ngModel)]="status" aria-label="status levels" [hideSingleSelectionIndicator]="false">
                    <mat-button-toggle *ngFor="let level of statuses" [value]="level.value">
                         {{
                         {
                            muted: ('shared_projects.mute' | transloco),
                            accepted: ('shared_projects.accept' | transloco),
                            rejected: ('shared_projects.reject' | transloco)
                            }[level.value]
                        }}
                    </mat-button-toggle>
                </mat-button-toggle-group>
            </div>

            <div class="pull-right mt-20">
                <button data-cy="generic-share-items__save-btn" mat-flat-button class="save-btn" [disabled]="status === 'muted' || isProcessing()" (click)="onSaveItem()">
                    <mat-spinner *ngIf="false" [diameter]="14" class="d-text-middle"></mat-spinner> {{ 'save' | transloco | capitaliz }}
                </button>
            </div>
        </div>

        <button data-cy="generic-share-items__toggle-dropdown-btn" mat-stroked-button (click)="toggleDropdown()" *ngIf="!isReadOnly" [disabled]="entity?.status==='accepted' || isSharedSubproject()">
            <i class="uil uil-share-alt"></i>
            <span class="share-item-text">{{'shared_projects.external_share' | transloco }}</span>
        </button>
        <div class="share-dropdown" *ngIf="isDropdownOpen">
            <mat-progress-bar mode="" *ngIf="!loaded()"></mat-progress-bar>
            <div class="flex direction-column gap-8" *ngIf="loaded() && isAdmin">
                <h1 class="mb-5">{{'shared_projects.share' | transloco }}</h1>
                <mat-divider></mat-divider>
                <!-- <div class="flex justify-btw align-center py-4">
                    <span>{{'shared_projects.share_info_externally' | transloco }}</span>
                    <mat-icon [style.color]="'#2800d2'" class="uil uil-angle-right-b d-text-middle d-cursor-hand" (click)="openExternalConnectionalModal()"></mat-icon>
                </div>
                <mat-divider></mat-divider> -->
                <div class="flex justify-btw align-center py-4 d-cursor-hand" (click)="navigateToKaart()">
                    <span>{{'shared_projects.start_connection_request' | transloco }}</span>
                    <mat-icon [style.color]="'#2800d2'" class="uil uil-angle-right-b d-text-middle"></mat-icon>
                </div>
                <mat-divider></mat-divider>
            </div>

            <div class="mt-30" *ngIf="loaded()" [class.share-action-disabled]="isReader">
                <h1>{{'shared_projects.to_manage' | transloco }}</h1>
                <div class="mt-30">
                    <app-generic-multiselect-checkbox data-cy="generic-share-items__generic-multiselect-checkbox" [placeholder]="'Extern gedeeld met:'" name="sharedProjects"
                        [(ngModel)]="selectedVisibleProjects" ngDefaultControl (ngModelChange)="onProjectSelection($event)" [uniqueId]="'shared-projects'"
                        [disabled]="isReader" [readOnly]="isReader">
                        <app-generic-multiselect-checkbox-option *ngFor="let proj of allProjects" [value]="proj">
                            {{ globals.project.projects_id===proj.source_project_id ? proj.target_project.name: proj.source_project.name }}
                        </app-generic-multiselect-checkbox-option>
                    </app-generic-multiselect-checkbox>
                </div>
                <!-- <p class="underline pull-right" [style.color]="'#2800d2'">{{'shared_projects.show_all' | transloco }}</p> -->
            </div>
        </div>
    </div>
</div>
